// Google Analytics Event Tracking Utility

// Function to track Google Analytics events
export const trackGAEvent = (eventName, eventCategory = 'CTA', eventLabel = '', eventValue = null) => {
  // Check if gtag is available (Google Analytics 4)
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, {
      event_category: eventCategory,
      event_label: eventLabel,
      value: eventValue,
    });
  }

  // Fallback for Universal Analytics (ga)
  if (typeof window !== 'undefined' && window.ga) {
    window.ga('send', 'event', eventCategory, eventName, eventLabel, eventValue);
  }
};

// Predefined CTA event names for consistency
export const GA_EVENTS = {
  // Header/Navigation Events
  HEADER_LETS_CONNECT: 'header_lets_connect_click',
  HEADER_HOME: 'header_home_click',
  HEADER_ABOUT: 'header_about_click',
  HEADER_BLOG: 'header_blog_click',
  HEADER_CONTACT: 'header_contact_click',
  HEADER_WHAT_WE_DO: 'header_what_we_do_click',
  HEADER_WHO_WE_HELP: 'header_who_we_help_click',

  // Home Page Events
  HOME_LETS_CONNECT: 'home_hero_lets_connect_click',
  HOME_GET_STARTED: 'home_boost_get_started_click',
  HOME_EXPLORE_MORE: 'home_explore_more_click',
  HOME_PHONE_CONTACT: 'home_phone_contact_click',
  HOME_EMAIL_CONTACT: 'home_email_contact_click',
  HOME_TALK_TO_EXPERT: 'home_talk_to_expert_click',
  HOME_CONTACT_US_FAQ: 'home_faq_contact_us_click',

  // About Page Events
  ABOUT_GET_STARTED: 'about_get_started_click',
  ABOUT_CONTACT_US_FAQ: 'about_faq_contact_us_click',
  ABOUT_TALK_TO_EXPERT: 'about_talk_to_expert_click',

  // Contact Page Events
  CONTACT_QUICK_CONTACT: 'contact_quick_contact_click',
  CONTACT_SCHEDULE_DEMO: 'contact_schedule_demo_click',

  // Blog Page Events
  BLOG_READ_ARTICLE: 'blog_read_article_click',
  BLOG_READ_MORE: 'blog_read_more_click',
  BLOG_CATEGORY_FILTER: 'blog_category_filter_click',
  BLOG_PAGINATION: 'blog_pagination_click',

  // Service Pages Events
  SERVICE_CREDENTIALING: 'service_credentialing_click',
  SERVICE_ACCOUNTS_RECEIVABLE: 'service_accounts_receivable_click',
  SERVICE_DENIAL_MANAGEMENT: 'service_denial_management_click',
  SERVICE_CHARGE_ENTRY_AUDIT: 'service_charge_entry_audit_click',
  SERVICE_ACCOUNT_RECONCILIATION: 'service_account_reconciliation_click',
  SERVICE_PAYMENT_POSTING: 'service_payment_posting_click',

  // Industry Pages Events
  INDUSTRY_NURSE_PRACTITIONERS: 'industry_nurse_practitioners_click',
  INDUSTRY_MENTAL_HEALTH: 'industry_mental_health_click',
  INDUSTRY_CHIRO: 'industry_chiro_click',
  INDUSTRY_FAMILY_MEDICINE: 'industry_family_medicine_click',
  INDUSTRY_INTERNAL_MEDICINE: 'industry_internal_medicine_click',
  INDUSTRY_PT: 'industry_pt_click',

  // Form Events
  FORM_SUBMIT_HEADER: 'form_submit_header_modal',
  FORM_SUBMIT_HOME: 'form_submit_home_modal',
  FORM_SUBMIT_ABOUT: 'form_submit_about_modal',
  FORM_SUBMIT_CONTACT: 'form_submit_contact_modal',
};
